import { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import React from 'react'

import 'components/LayoutPage/LayoutScroll/LayoutScroll.module.scss'

import './Scrollbar.module.scss'
import { useScrollbarProps } from './useScrollbarProps'

export type ScrollbarRef = OverlayScrollbarsComponent

interface IScrollbarProps {
  children?: React.ReactNode
}

const Scrollbar = React.forwardRef<ScrollbarRef, IScrollbarProps>(({ children }, ref) => {
  const props = useScrollbarProps()

  return (
    <OverlayScrollbarsComponent {...props} ref={ref}>
      {children}
    </OverlayScrollbarsComponent>
  )
})

Scrollbar.displayName = 'Scrollbar'

export default React.memo(Scrollbar)
